module.exports = __webpack_public_path__ + "img/ne.f1c7f30e.svg";